export default "__VITE_ASSET__CyOW0c1N__"